export const TEST_CONTAINER = "test";
export const DOCUMENTS_CONTAINER = "document";
export const PROFILE_CONTAINER = "profile";
export const NOTEPAD_CONTAINER = "notepad";
export const NOTEPAD_IMAGES_CONTAINER = "notepadimages";
